<template>
  <transition name="modal">
    <div class="modal-mask">
        <div v-bind:class="width" class="row large-centered modal-container">
          <div class="panel-title modal-title">
            <slot name="header">
              <div>
              Default Header
              </div>
            </slot>
            <hr>
          </div>
          <div class="panel-content">
            <slot name="body">
              default body
            </slot>
            <hr>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="modal-default-button" @click="$emit('close')">
                OK
              </button>
            </slot>
          </div>
        </div>
      </div>
</transition>
</template>

<script>
export default {
  name: 'modal',
  props: {
    'size': String
  },
  computed: {
    width: function () {
      if (this.size === 'large') {
        return 'large-9'
      }
      if (this.size === 'medium') {
        return 'large-6'
      }
      if (this.size === 'small') {
        return 'large-4'
      }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-mask {
  position:fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 1000%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  margin: 0px auto;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-default-button {
  float: right;
}

.modal-title {
    text-align: center;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// modal.vue?6f83d20e